import React from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { StyleRoot } from 'radium';

import App from './App';
import reducer from '../reducers';

const store = createStore(reducer, applyMiddleware(thunkMiddleware));

const Root = () => (
  <Provider store={store}>
    <MuiThemeProvider>
      <StyleRoot>
        <App />
      </StyleRoot>
    </MuiThemeProvider>
  </Provider>
);

export default Root;



// WEBPACK FOOTER //
// ./src/containers/Root.js